import { useDispatch, useSelector } from "react-redux";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { useEffect } from "react";
import { fetchScheduledCandidates } from "../../../Slices/hiringSlice";
import { useNavigate } from "react-router-dom";

const InterviewList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const interviewList = useSelector((state) => state.hiring.interviewList);

    useEffect(()=>{
        dispatch(fetchScheduledCandidates())
    },[dispatch])

    const columns = [
        {
            title: "Candidate Id",
            dataIndex:"candidateId"
        },
        {
            title: "Candidate Name",
            render: (_, row) => {
                const fullName = `${row.firstName} ${row.lastName || ""}`;
                return (
                    <span>
                        {fullName}
                    </span>

                );
            }
        },
        {
            title: "Stage",
            dataIndex:"stage"
        },
        {
            title: "Status",
            dataIndex:"status"
        },
        {
            title: "email",
            dataIndex:"email"
        },
        {
            title: "Job Title",
            dataIndex:"jobTitle"
        }
    ];

   const handleRowClick = (record) => {
    navigate(`/InterviewScheduling/${record.candidateId}`);
};


    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <CustomGridTable
                                columns={columns}
                                dataSource={interviewList}
                                pagination={{
                                    showSizeChanger: true,
                                }}
                                size="small"
                                scroll={{ x: false }}
                                onRow={(record) => ({
                                    onClick: () => handleRowClick(record)
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InterviewList;